<!-- M556Cards.vue -->
<template>
  <main class="wrap">
    <section class="grid">
      <!-- Get App -->
      <button
        class="card"
        @click="
          $playSound();
          showDownloadModal = true;
        "
        tabindex="0"
        type="button"
        aria-label="အက်ပ်ဒေါင်းလုဒ်"
      >
        <span class="icon">
          <!-- phone-download -->
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm5 16 3-3h-2V8h-2v7H9l3 3Zm-1 2h2"
              fill="currentColor"
            />
          </svg>
        </span>
        <h3>အက်ပ်ဒေါင်းလုဒ်</h3>
        <p class="muted">Android / iOS</p>
      </button>

      <van-popup
        v-model="showDownloadModal"
        round
        closeable
        position="bottom"
        class="download-popup"
      >
        <div class="download-panel">
          <h4>အက်ပ်ဒေါင်းလုဒ်</h4>
          <p>သင့်စက်ပစ္စည်းအမျိုးအစားကို ရွေးချယ်ပါ</p>
          <div class="download-options">
            <a
              :href="androidApkUrl"
              download="BaganMoung.apk"
              class="download-option"
              @click="$playSound()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fill="currentColor"
                  d="M1 18q.225-2.675 1.638-4.925T6.4 9.5L4.55 6.3q-.15-.225-.075-.475T4.8 5.45q.2-.125.45-.05t.4.3L7.5 8.9Q9.65 8 12 8t4.5.9l1.85-3.2q.15-.225.4-.3t.45.05q.25.125.325.375t-.075.475L17.6 9.5q2.35 1.325 3.762 3.575T23 18zm6-2.75q.525 0 .888-.363T8.25 14t-.363-.888T7 12.75t-.888.363T5.75 14t.363.888t.887.362m10 0q.525 0 .888-.363T18.25 14t-.363-.888T17 12.75t-.888.363t-.362.887t.363.888t.887.362"
                />
              </svg>
              <span>Android ဒေါင်းလုဒ်</span>
            </a>
            <a
              :href="iosConfigUrl"
              class="download-option"
              @click="$playSound()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fill="currentColor"
                  d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
                />
              </svg>
              <span>iOS ဒေါင်းလုဒ်</span>
            </a>
          </div>
        </div>
      </van-popup>

      <button
        @click="() => $router.push('/auth/register')"
        class="card"
        tabindex="0"
        aria-label="ကိုယ်တိုင် မှတ်ပုံတင်"
      >
        <span class="icon">
          <!-- user-plus -->
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M15 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-2 7H7a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5Zm8-6h-2V7h-2V5h2V3h2v2h2v2h-2v2Z"
              fill="currentColor"
            />
          </svg>
        </span>
        <h3>ကိုယ်တိုင် မှတ်ပုံတင်</h3>
        <p class="muted">အချက်အလက်ဖြည့်ပြီး တန်းသုံးမည်</p>
      </button>

      <!-- Contact admin to get account -->
      <button
        class="card"
        tabindex="0"
        type="button"
        @click="
          $playSound();
          showContactModal = true;
        "
        aria-label="အကောင့်ရရန် အက်မင်ကို ဆက်သွယ်ပါ"
      >
        <span class="icon">
          <!-- headset/admin -->
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M12 3a7 7 0 0 0-7 7v4a3 3 0 0 0 3 3h2v-6H6v-1a6 6 0 1 1 12 0v1h-4v6h2a3 3 0 0 0 3-3v-4a7 7 0 0 0-7-7Z"
              fill="currentColor"
            />
          </svg>
        </span>
        <h3>အကောင့်ရရန် အက်မင်ကို ဆက်သွယ်ပါ</h3>
        <p class="muted">အကောင့်အတွက် အကူအညီ</p>
      </button>

      <van-popup
        v-model="showContactModal"
        round
        closeable
        position="bottom"
        class="contact-popup"
      >
        <div class="contact-panel">
          <h4>အကောင့်ရရန် အက်မင်ကို ဆက်သွယ်ပါ</h4>
          <p>Telegram သို့မဟုတ် Viber မှ customer service ကို ဆက်သွယ်ပါ</p>
          <div class="contact-options">
            <a
              :href="telegramLink"
              target="_blank"
              rel="noopener noreferrer"
              class="contact-option"
              @click="$playSound()"
            >
              <img
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/smt223_telegram.png"
                alt="Telegram"
                class="contact-icon-img"
              />
              <span>Telegram</span>
            </a>
            <a
              :href="viberLink"
              class="contact-option"
              @click="$playSound()"
            >
              <img
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/smt223_viber.png"
                alt="Viber"
                class="contact-icon-img"
              />
              <span>Viber</span>
            </a>
          </div>
        </div>
      </van-popup>

      <!-- Login -->
      <button
        class="card"
        @click="() => $router.push('/auth/login')"
        tabindex="0"
        aria-label="လော့ဂ်အင်"
      >
        <span class="icon">
          <!-- lock-login -->
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M17 8h-1V6a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2ZM10 6a2 2 0 1 1 4 0v2h-4V6Zm2 6a2 2 0 0 1 1 3.732V18h-2v-2.268A2 2 0 0 1 12 12Z"
              fill="currentColor"
            />
          </svg>
        </span>
        <h3>လော့ဂ်အင်</h3>
        <p class="muted">အကောင့်သို့ ဝင်ရောက်ပါ</p>
      </button>
    </section>
  </main>
</template>

<script>
export default {
  data() {
    return {
      showContactModal: false,
      showDownloadModal: false,
      telegramLink: "https://t.me/bgnmoung_bot",
      viberLink: "https://msng.link/o/?959961896222=vip",
      androidApkUrl: "/apks/BaganMoung.apk",
      iosConfigUrl: "/apks/baganmoung.mobileconfig",
    };
  },
};
</script>

<style scoped>
/* ===== Theme (inspired by screenshot) ===== */

.wrap {
  min-height: 100dvh;
  background: linear-gradient(
    180deg,
    var(--bg-olive-2) 0%,
    var(--bg-olive) 22%,
    var(--bg-olive) 100%
  );
  display: grid;
  place-items: start center;
  padding: 28px 16px 48px;
}

.grid {
  width: 100%;
  display: grid;
  margin-top: 50px;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 14px;
}

@media (max-width: 640px) {
  .grid {
    grid-template-columns: 1fr 1fr;
  }
}

.card {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 14px;
  justify-items: center;
  text-align: center;
  padding: 18px 18px;
  border-radius: 14px;
  background: var(--card-bg);
  color: var(--text);
  text-decoration: none;
  border: 1px solid var(--card-border);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  transition: transform 0.18s ease, box-shadow 0.18s ease,
    border-color 0.18s ease;
  outline: none;
}

.card:focus-visible {
  box-shadow: 0 0 0 4px var(--ring), 0 10px 24px rgba(0, 0, 0, 0.12);
  border-color: var(--primary);
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.12);
  border-color: #dce7db;
}

.icon {
  width: 56px;
  height: 56px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.icon svg {
  width: 28px;
  height: 28px;
}

h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--primary-700);
}

.muted {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--text-muted);
}

.contact-panel {
  padding: 20px 16px 28px;
  background: #1c1c1c;
}

.contact-panel h4 {
  margin: 0 0 8px;
  color: #f0e6c8;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
}

.contact-panel p {
  margin: 0 0 18px;
  color: #c9c3b8;
  font-size: 0.82rem;
  text-align: center;
}

.contact-options {
  display: flex;
  gap: 12px;
}

.contact-option {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 16px 12px;
  border-radius: 12px;
  background: #161616;
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-decoration: none;
}

.contact-icon-img {
  width: 52px;
  height: 52px;
  object-fit: contain;
  border-radius: 12px;
}

.contact-option span {
  color: #f0e6c8;
  font-size: 0.9rem;
  font-weight: 600;
}

.download-panel {
  padding: 20px 16px 28px;
  background: #1c1c1c;
}

.download-panel h4 {
  margin: 0 0 8px;
  color: #f0e6c8;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
}

.download-panel p {
  margin: 0 0 18px;
  color: #c9c3b8;
  font-size: 0.82rem;
  text-align: center;
}

.download-options {
  display: flex;
  gap: 12px;
}

.download-option {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 16px 12px;
  border-radius: 12px;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  border: 1px solid rgba(255, 255, 255, 0.12);
  text-decoration: none;
  color: #1a1408;
}

.download-option svg {
  color: #1a1408;
}

.download-option span {
  font-size: 0.88rem;
  font-weight: 700;
  text-align: center;
  line-height: 1.3;
}
</style>

<style>
.contact-popup.van-popup {
  background: #1c1c1c;
}
.contact-popup .van-popup__close-icon {
  color: #f0e6c8;
}
.download-popup.van-popup {
  background: #1c1c1c;
}
.download-popup .van-popup__close-icon {
  color: #f0e6c8;
}
</style>
